import {
  ColumnOrganizerType,
  ColumnType,
  ColumnWidth,
  GenericTableLabels,
  Pinned,
  TableDefinition,
} from '@vendasta/va-filter2-table';
import { ListingSyncTableFilterService } from './listing-sync-table-filter.service';
import { SourceNameColumnComponent } from './columns/source-name-column/source-name-column.component';
import { StatusColumnComponent } from './columns/status-column/status-column.component';
import { PresenceAccuracyComponent } from './columns/presence-accuracy/presence-accuracy.component';

const COMMON_TABLE_LABELS: GenericTableLabels = {
  noResults: 'LISTING_SYNC.TABLE_LABEL.NO_RESULTS',
  cancel: 'LISTING_SYNC.TABLE_LABEL.CANCEL',
  none: 'LISTING_SYNC.TABLE_LABEL.NONE',
  update: 'LISTING_SYNC.TABLE_LABEL.UPDATE',
  sortBy: 'LISTING_SYNC.TABLE_LABEL.SORT_BY',
  thenSortBy: 'LISTING_SYNC.TABLE_LABEL.THEN_SORT_BY',
  addAnotherSortColumn: 'LISTING_SYNC.TABLE_LABEL.ADD_SORT_COLUMN',
  chooseColumnToSortBy: 'LISTING_SYNC.TABLE_LABEL.CHOOSE_SORT_COLUMN',
  columnSorting: {
    date: {
      ascending: 'LISTING_SYNC.TABLE_LABEL.SORT_DATE_ASC',
      descending: 'LISTING_SYNC.TABLE_LABEL.SORT_DATE_DSC',
    },
    number: {
      ascending: 'LISTING_SYNC.TABLE_LABEL.SORT_NUMBER_ASC',
      descending: 'LISTING_SYNC.TABLE_LABEL.SORT_NUMBER_DSC',
    },
    string: {
      ascending: 'LISTING_SYNC.TABLE_LABEL.SORT_STRING_ASC',
      descending: 'LISTING_SYNC.TABLE_LABEL.SORT_STRING_DSC',
    },
    default: {
      ascending: 'LISTING_SYNC.TABLE_LABEL.SORT_DEFAULT_ASC',
      descending: 'LISTING_SYNC.TABLE_LABEL.SORT_DEFAULT_DSC',
    },
  },
  export: {
    buttonText: '',
    buttonTooltipBeforeCount: '',
    buttonTooltipAfterCount: '',
    description: 'LISTING_SYNC.TABLE_LABEL.EXPORT',
  },
  columnSelector: {
    buttonText: 'LISTING_SYNC.TABLE_LABEL.COLUMN_SELECTOR',
  },
};

const LISTING_SYNC_TABLE_DEF: TableDefinition = {
  id: 'listing-sync',
  labels: COMMON_TABLE_LABELS,
  columns: [
    {
      id: 'sourceName',
      field: 'name',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.SITE_NAME',
      type: ColumnType.COLUMN_TYPE_STRING,
      cellComponent: SourceNameColumnComponent,
      pinned: Pinned.PINNED_LEFT,
      sortOptions: { sortable: true },
      width: ColumnWidth.WIDTH_WIDE,
    },
    {
      id: 'listingAccuracy',
      field: 'accuracyText',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.LISTING_ACCURACY',
      type: ColumnType.COLUMN_TYPE_STRING,
      cellComponent: PresenceAccuracyComponent,
      sortOptions: { sortable: true },
    },
    {
      id: 'syncStatus',
      field: 'syncText',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.STATUS',
      type: ColumnType.COLUMN_TYPE_STRING,
      cellComponent: StatusColumnComponent,
      sortOptions: { sortable: true },
    },
    {
      id: 'score',
      field: 'score',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.SCORE',
      type: ColumnType.COLUMN_TYPE_NUMBER,
      sortOptions: { sortable: true },
    },
    {
      id: 'scoreMax',
      field: 'maxScore',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.MAX_SCORE',
      type: ColumnType.COLUMN_TYPE_NUMBER,
      sortOptions: { sortable: true },
    },
    {
      id: 'lastUpdated',
      field: 'lastUpdated',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.LAST_UPDATED',
      type: ColumnType.COLUMN_TYPE_STRING,
      sortOptions: { sortable: true },
    },
    {
      id: 'sourceType',
      field: 'sourceType',
      displayName: 'LISTING_SYNC.COLUMN_HEADERS.SITE_TYPE',
      type: ColumnType.COLUMN_TYPE_STRING,
      sortOptions: { sortable: true },
    },
  ],
  groups: [],
  columnOrganizerType: ColumnOrganizerType.ADVANCED_ORGANIZER,
  options: {
    pageSizeOptions: [10, 25, 50],
    defaultPageSize: 50,
  },
};

export const tableDefinitionFactory = (filterService: ListingSyncTableFilterService) => {
  const tableDefinition = LISTING_SYNC_TABLE_DEF;
  tableDefinition.filters = filterService.filters;
  return tableDefinition;
};
